import { BLANK_SCREEN_MONITOR_PLUGIN_NAME, BlankScreenMonitorPlugin } from '@slardar/sdk-web';
export var blankScreenPlugin = function (blankScreenConfig) { return ({
    name: BLANK_SCREEN_MONITOR_PLUGIN_NAME,
    setup: function (client) {
        BlankScreenMonitorPlugin(client, blankScreenConfig);
    },
}); };
//# sourceMappingURL=blankscreen.js.map